import { AppJsonDecoder } from '../utils/app-json-decoder';
import { User } from './user/user.model';

export default class DisciplineRecord {
  id?: string;
  author?: User;
  user?: User;
  school_year?: string;
  date?: Date;
  type?: string;
  text?: string;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(json?: any) {
    if (!json) return;
    this.id = json['_id'] || json['id'];
    this.author = json['author'] ? new User(json['author']) : undefined;
    this.user = json['user'] ? new User(json['user']) : undefined;
    this.date = AppJsonDecoder.optDate(json['date']);
    this.school_year = json['school_year'];
    this.type = json['type'];
    this.text = json['text'];
    this.createdAt = AppJsonDecoder.optDate(json['createdAt']);
    this.updatedAt = AppJsonDecoder.optDate(json['updatedAt']);
  }
}
